import { SET_NOTIFS, SET_NOTIFS_LOADING, SET_NOTIFS_IMPORTANT } from '../actions/types'

const initialState = {
    notifs : [],
    loading : false
}

export default (state = initialState, action) => {
    switch(action.type){
        case SET_NOTIFS_LOADING :
            return { ...state, loading : action.payload}
        case SET_NOTIFS : 
            return { ...state, notifs : action.payload.notifs}
        case SET_NOTIFS_IMPORTANT : 
            return { ...state, item : action.payload}
        default : 
            return state
    }
}